module.exports = __webpack_public_path__ + "img/net.6ef693a3.jpg";